// extracted by mini-css-extract-plugin
export default {"container":"Home_container__36mq4","paddingTop":"Home_paddingTop__apRXM","horizontalContainer":"Home_horizontalContainer__2XaTT","normalText":"Home_normalText__NNHUN"};